export default __webpack_public_path__ + "static/media/opis.1090dc88.PNG";